import { useSelector } from "react-redux"
import { Navigate, useNavigate } from "react-router-dom"
import { Spinner } from "../components/Loading"

export const PrivateRouter = ({ Component, ...props }) => {
  const navigate = useNavigate()
  const currentUser = useSelector((state) => state.app.user)
  const rehydrated = useSelector((state) => state.app.rehydrated)

  if(!rehydrated){
    return <Spinner size="large" color="orange"/>
  }

  if (!currentUser || !currentUser.access_token) {
    // Preservar parâmetros da URL ao redirecionar para login
    const search = window.location.search
    return <Navigate to={`/authentication/login${search}`}/>
  }

  return <Component {...props} navigate={navigate} />
}
